<template>
  <div>
    <span :class="{ 'text-left': true, 'required': required }">
      {{ label }}
    </span>
    <v-text-field
      :class="{ 'input-control': true, 'append-unit': unit }"
      v-model="textValue"
      :type="type"
      outlined
      dense
      hide-details
      :height="height"
      :required="required"
      v-bind:placeholder="placeholder">
      <template v-if="unit" v-slot:append>
        <div class="d-flex unit justify-content-center align-items-center">
          <span class="pb-0">{{ unit }}</span>
        </div>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: "LabelTextField",
  props: {
    label: String,
    placeholder: String,
    required: Boolean,
    unit: String,
    height: {
      type: [Number, String],
      default: 41
    },
    type:{
      type:String,
      default:'text'
    }
  },
  data() {
    return {
      textValue: ''
    }
  },
  watch: {
    textValue: function () {
      this.$emit('change', this.textValue)
    }
  }
}
</script>

<style scoped>
span {
  display: flex;
  font-size: 0.75rem;
  font-weight: bold;
  color: #b0bac9;
  padding-bottom: 0.5rem;
}

.required::after {
  content: "*";
  margin-left: 0.25rem;
  color: red;
}

.unit {
  width: 3.25rem;
  height: 1.875rem;
  padding-bottom: 0;
  border: 1px solid #e0e7ff;
  border-radius: 0.3125rem;
  background: white;
}

.unit span {
  font-size: 1.125rem;
  font-weight: 500;
  color: #7b7b7b;
}

</style>